export default { 
    ADMIN: 'ADMIN',
    USER: 'USER', 
};